import { styled, Flex } from '@withjoy/joykit';

export const StyledFlex = styled(Flex)<{ $disabled: boolean }>`
  ${({ $disabled }) => $disabled && 'cursor: none; pointer-events: none'};
`;
